<template>
  <!-- ホルター心電図解析 -->
  <div id="HolterJudgmentDetail">
    <div id="container">
      <div class="labelTitle lable">ホルター心電図解析 判定依頼</div>
      <div class="button-area">
        <b-button
          class="backButton is-primary"
          @click="back">戻る</b-button>
      </div>
      <div id="item-contens">
        <div class="card-content margin-top">
          <table>
            <tr><th>受付番号</th><td>{{ data.receiptNumber }}<span
              v-if="data.depositMachineFlag"
              class="depo"/></td></tr>
            <tr><th>返却希望日</th><td>{{ data.returnDate }}</td></tr>
            <tr><th>解析日</th><td>{{ data.analysisDay }}</td></tr>
            <tr><th>解析担当者</th><td>{{ data.analysisStaffName }}</td></tr>
            <tr><th>解析実施者</th><td>{{ data.analysisExecStaffName }}</td></tr>
            <tr v-if="!data.holterRequestId"><th>解析方法</th><td>{{ data.analysisMethod | choiceFilter(analysisMethodList) }}</td></tr>
            <tr v-if="data.holterRequestId"><th>解析方法</th><td>ホルター心電図</td></tr>
            <tr><th>解析オプション</th><td>{{ data.analysisOption | choiceFilter(analysisOptionList) }}</td></tr>
            <tr><th>検査日</th><td>{{ data.inspectionDate }}</td></tr>
            <tr>
              <th>判定医<span class="require"/></th>
              <td>
                <input
                  v-model="data.analyistName"
                  type="text"
                  disabled="disabled"
                  style="width:700px;"
                  class="edit"
                  name="判定医"
                  validate="required">
                <b-button
                  v-if="status == '判定依頼中' || status == '判定中'"
                  style="margin-left:10px; width:150px; height:27px;"
                  @click="holterJudgmentModalActive=true">判定医選択</b-button>
              </td>
            </tr>
            <tr><th>判定期限</th><td>{{ data.judgmentDocterAnalysisLimit }}</td></tr>
            <tr><th style="vertical-align:top;">備考</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><div class="indentionArea printIndentionArea">{{data.receptionNote}}</div></td>
            </tr>
          </table>
        </div>
        <div
          v-if="status === '判定依頼中'"
          class="button-area">
          <b-button
            class="is-primary"
            @click="approval">判定依頼
          </b-button>
        </div>
        <div
          v-if="status === '判定中'"
          class="button-area">
          <b-button
            class="is-primary"
            @click="changeJudgmentDoctor">更新
          </b-button>
        </div>
        <div style="height:5px;" />
        <div class="labelTitle lable">申込内容</div>
        <div id="item-contens">
          <holterAnalysisRequestDetail v-if="hasDetailData" v-bind:data="detailData" :canDownload="true" :editFlag="false" :hstRequestId="data.holterRequestId" :belongsNote="data.belongsNote" :isInternalPsg="true" />
        </div>
      </div>
    </div>
    
    <b-modal
      :active.sync="holterJudgmentModalActive"
      has-modal-card>
      <HolterJudgmentModal
        title="判定医選択"
        label-for-org="判定医"
        @select="setAnalyist"/>
    </b-modal>
  </div>
</template>

<script>
import {atLaunchHidden, choicesType, UploadType, requestStatus} from '@/components/mock/base/const.js'

import holterAnalysisRequestDetail from '@/components/mock/common/HolterAnalysisRequestDetail'
import HolterJudgmentModal from '@/components/mock/philips/common/HolterJudgmentModal'

export default {
  name: 'HolterJudgmentDetail',
  filters: {
    choiceFilter: function (val, list) {
      if (!val) return val
      const target = list.find(item => item.value === val)
      if (target) {
        return target.label1
      }
      return ''
    }
  },
  components: {
    holterAnalysisRequestDetail: holterAnalysisRequestDetail,
    HolterJudgmentModal: HolterJudgmentModal
  },
  data () {
    const analysisMethodList = this.getChoiceList(choicesType.holterMethod, true)
    const analysisOptionList = this.getChoiceList(choicesType.holterAnalysisOp, true)
    const item = this.$route.params['item']
    const receiptNumber = item.receiptNumber
    const status = item.status
    const analysisMethod = item.analysisMethod
    const version = item.version
    const searchParams = this.$route.params['searchConditions']
    const detailData = {fileInfo: {}}
    const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    let roleId = ''
    const fileReplaceStatus = [requestStatus.resultSendReady,
      requestStatus.completion,
      requestStatus.salesAppropriation,
      requestStatus.completionAppropriation
    ]
    if (userInfo) {
      roleId = userInfo.roleId
    }
    return {
      data: [],
      receiptNumber,
      detailData,
      searchParams,
      upFiles: [],
      status,
      analysisMethod,
      dismissalReasonInputModalActive: false,
      cancelReasonInputModalActive: false,
      holterJudgmentModalActive: false,
      hasDetailData: false,
      editMode: false,
      replaceFiles: [],
      UploadType: UploadType,
      isUpdateModal: false,
      upButtonFile: null,
      fileReplaceStatus,
      version,
      analysisMethodList: analysisMethodList,
      analysisOptionList: analysisOptionList,
      atLaunchHidden: atLaunchHidden,
      uploadFileName: '',
      roleId: roleId,
      isCvhriNotCalcCheck: false,
      currentJudgmentDocterId: null,

    }
  },
  mounted: function () {
    // 解析結果承認詳細取得
    this.getApprovalDetail()
    // 申込内容取得
    this.getDetail()
  },
  methods: {
    getApprovalDetail: function () {
      const excuteApi = this.getHolterAnalysisResultApprovalDetailPOST
      const successCallBack = this.getHolterAnalysisResultApprovalDetailPOSTSuccess
      const errorCallBack = this.getHolterAnalysisResultApprovalDetailPOSTError
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack)
    },
    getHolterAnalysisResultApprovalDetailPOST: function (client) {
      return client.apis.internalHolterAnalysis.getHAnalysisResultApprovalDetailPOST({
        body: { receiptNumber: this.receiptNumber }
      })
    },
    getHolterAnalysisResultApprovalDetailPOSTSuccess: function (result) {
      this.data = result.obj
      this.version = this.data.version
      this.resultVersion = this.data.resultVersion
      this.replaceFiles = this.getCopy(this.data.fileInfo)
      this.data.af = this.data.afKind
      this.uploadFileName = this.data.patientId + '_' + this.data.requestDate + '_' + this.data.hospitalName + '_' + this.data.patientName + '様'
      this.uploadFileName = this.uploadFileName.replace(/[\\/:*?"<>|]/g, '_')
      if (this.data.cvhri === -1) {
        // CVHRI算出不可案件の場合(cvhri=-1)、初期値としてチェックボックス(CVHRI算出不可)をtrue(チェック有)とする
        this.isCvhriNotCalcCheck = true
        this.data.cvhri = null
      }

      if(this.status === "判定中" || this.status === "判定済み" || this.status === "ファイル差替中"){
        this.currentJudgmentDocterId = this.data.judgmentDocterId
        this.data.analyist = this.currentJudgmentDocterId
        this.data.analyistName = this.data.judgmentDocterName
      }
    },
    getHolterAnalysisResultApprovalDetailPOSTError: function (result) {
      // エラーメッセージ表示
      this.showErrorMessage(result)
    },
    getDetail: function () {
      const excuteApi = this.getAnalysisDetailPOST
      const successCallBack = this.getAnalysisDetailPOSTSuccess
      const errorCallBack = this.getAnalysisDetailPOSTError
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack)
    },
    getAnalysisDetailPOST: function (client) {
      return client.apis.internalHolterAnalysis.getHAnalysisRequestDetailPOST({
        body: {receiptNumber: this.receiptNumber}
      })
    },
    getAnalysisDetailPOSTSuccess: function (result) {
      const res = result.obj
      this.upFiles = res.analysisResultFileList
      this.detailData = res.applicationDetails
      this.hasDetailData = true
    },
    getAnalysisDetailPOSTError: function (result) {
      // エラーメッセージ表示
      this.showErrorMessage(result)
      this.back()
    },
    back: function () {
      this.$router.push({
        name: 'HolterJudgment',
        params: { searchConditions: this.searchParams }
      })
    },
    setAnalyist: function (analyistInfo) {
      this.data.analyist = analyistInfo.id
      this.data.analyistName = analyistInfo.orgName
    },
    approval: function () {
      const elements = document.getElementsByClassName('edit')
      const result = this.selfMadeValidation(elements)
      if (result.isError) {
        this.showErrorMessage(result.msg)
        return
      }
      let messsage = '判定医に依頼してよろしいでしょうか？'

      this.$dialog.confirm({
        title: '判定依頼確認',
        message: messsage,
        confirmText: 'はい',
        cancelText: 'いいえ',
        onConfirm: async () => {
          // 承認する
          const excuteApi = this.setHolterJudgmentAnalysistPOST
          const successCallBack = this.setHolterJudgmentAnalysistPOSTSuccess
          const errorCallBack = this.setHolterJudgmentAnalysistPOSTError
          // Web Api Call
          this.apiCall(excuteApi, successCallBack, errorCallBack)
        }
      })
    },
    setHolterJudgmentAnalysistPOST: function (client) {
      const obj = {
        receiptNumber: this.receiptNumber,
        judgmentDocterId: this.data.analyist, // 判定医ID
        version: this.version
      }
      return client.apis.internalHolterAnalysis.setHolterJudgmentAnalysistPOST({
        body: obj
      })
    },
    setHolterJudgmentAnalysistPOSTSuccess: async function (result) {
      this.showSuccess(result)
      this.back()
    },
    setHolterJudgmentAnalysistPOSTError: function (result) {
      // エラーメッセージ表示
      this.showErrorMessage(result)
      this.back()
    },
    
    changeJudgmentDoctor: function () {
      const elements = document.getElementsByClassName('edit')
      const result = this.selfMadeValidation(elements)
      if (result.isError) {
        this.showErrorMessage(result.msg)
        return
      }

      let messsage = '判定医の変更依頼をしてよろしいでしょうか？'

      this.$dialog.confirm({
        title: '判定医変更確認',
        message: messsage,
        confirmText: 'はい',
        cancelText: 'いいえ',
        onConfirm: async () => {
          // 承認する
          const excuteApi = this.changeHolterJudgmentAnalysistPOST
          const successCallBack = this.changeHolterJudgmentAnalysistPOSTSuccess
          const errorCallBack = this.changeHolterJudgmentAnalysistPOSTError
          // Web Api Call
          this.apiCall(excuteApi, successCallBack, errorCallBack)
        }
      })
    },
    changeHolterJudgmentAnalysistPOST: function (client) {
      const obj = {
        receiptNumber: this.receiptNumber,
        judgmentDocterId: this.data.analyist, // 判定医ID
        version: this.version, // バージョン
        resultVersion: this.resultVersion
      }
      return client.apis.internalHolterAnalysis.changeHolterJudgmentAnalysistPOST({
        body: obj
      })
    },
    changeHolterJudgmentAnalysistPOSTSuccess: async function (result) {
      this.showSuccess(result)
      this.back()
    },
    changeHolterJudgmentAnalysistPOSTError: function (result) {
      // エラーメッセージ表示
      this.showErrorMessage(result)
      this.back()
    },
  }
}
</script>
<style lang="scss" scoped>
table.flowTable,
table.flowTable tr,
table.flowTable td {
  border: 1px solid;
  padding: 0px;
  vertical-align: middle;
}
table.flowTable td {
  width: 40px;
  text-align: center;
}
.reject-reason-table {
  border-collapse: collapse;
  table-layout: fixed;
}
.reject-reason-table th {
  padding: 1px 0;
  border: 1px solid;
  text-align: center;
  vertical-align: middle;
}
.reject-reason-table td {
  padding: 1px 0 1px 10px;
  border: 1px solid;
  vertical-align: middle;
}
.reject-reason-table th.reject-date,
.reject-reason-table td.reject-date {
  width: 20% !important;
}
a {
  text-decoration: underline;
}
.uploadModal {
  width: 900px !important;
  height:500px !important;
  display: grid !important;
  place-items: center !important;
}
.clipbordcopy {
  margin-left:3%;
  right: 10px;
  width: 100px;
}

</style>



// WEBPACK FOOTER //
// src/components/mock/philips/holterAnalysis/HolterJudgmentDetail.vue